module.exports = __webpack_public_path__ + "img/edit.8ff06038.svg";